import buttons from 'shared/messages/source/buttons.json';
import errors from 'shared/messages/source/errors.json';
import forms from 'shared/messages/source/forms.json';
import kiosk from 'shared/messages/source/kiosk.json';
import cart from 'shared/messages/source/cart.json';
import consumer from 'shared/messages/source/consumer.json';
import hpx_disclaimer from 'shared/messages/source/hpx_disclaimer.json';

const messages = {
  ...buttons,
  ...errors,
  ...forms,
  ...kiosk,
  ...cart,
  ...consumer,
  ...hpx_disclaimer,
}

export default messages;
